import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useApplicantSession } from '@/lib/applicant/useApplicantSession';

/** Sends anybody without an applicant session to the applicant sign-in, and back after. */
export function RequireApplicant({ children }: { children: ReactNode }) {
  const { applicant, loading } = useApplicantSession();
  const location = useLocation();
  if (loading) return null;
  if (!applicant) {
    return <Navigate to="/apply/signin" replace state={{ from: location.pathname + location.search }} />;
  }
  return <>{children}</>;
}
